import { FC } from 'react';
import { Calendar, Clock, DollarSign, Users } from 'lucide-react';
import type { TherapistDashboardSection } from '../../../types/therapist-dashboard.types';

interface QuickActionsProps {
  onSectionChange: (section: TherapistDashboardSection) => void;
}

export const QuickActions: FC<QuickActionsProps> = ({ onSectionChange }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-slate-100 mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <button
          onClick={() => onSectionChange('schedule')}
          className="p-4 bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 hover:shadow-md transition-shadow text-left"
        >
          <Calendar className="w-6 h-6 text-blue-600 mb-2" />
          <p className="font-medium text-gray-900 dark:text-slate-100">View Schedule</p>
          <p className="text-sm text-gray-500 dark:text-slate-400">Check your calendar</p>
        </button>
        <button
          onClick={() => onSectionChange('availability')}
          className="p-4 bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 hover:shadow-md transition-shadow text-left"
        >
          <Clock className="w-6 h-6 text-green-600 mb-2" />
          <p className="font-medium text-gray-900 dark:text-slate-100">Update Availability</p>
          <p className="text-sm text-gray-500 dark:text-slate-400">Set your working hours</p>
        </button>
        <button
          onClick={() => onSectionChange('earnings')}
          className="p-4 bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 hover:shadow-md transition-shadow text-left"
        >
          <DollarSign className="w-6 h-6 text-purple-600 mb-2" />
          <p className="font-medium text-gray-900 dark:text-slate-100">View Earnings</p>
          <p className="text-sm text-gray-500 dark:text-slate-400">Track your income</p>
        </button>
        <button
          onClick={() => onSectionChange('clients')}
          className="p-4 bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 hover:shadow-md transition-shadow text-left"
        >
          <Users className="w-6 h-6 text-orange-600 mb-2" />
          <p className="font-medium text-gray-900 dark:text-slate-100">My Clients</p>
          <p className="text-sm text-gray-500 dark:text-slate-400">Manage client info</p>
        </button>
      </div>
    </div>
  );
};
